<template>
  <div class="homepage-news q-mb-md">
    <div class="news-list-container">
      <q-list>
        <q-item-label header class="header">{{ title }}</q-item-label>

        <q-item v-for="news in newsProp" :key="news.id">
          <q-item-section avatar class="date">
            <q-item-label caption>{{ formatDate(news.date) }}</q-item-label>
          </q-item-section>
          <q-item-section class="title">
            <q-item-label>
              <router-link
                style="text-decoration: none"
                :to="{ name: 'NewsDetails', params: { newsId: news.id } }"
                v-bind:target="openDetailsInNewTab ? '_blank' : null"
              >
                <span class="title"> {{ news.title }} </span>
              </router-link></q-item-label
            >
          </q-item-section>
        </q-item>
      </q-list>
    </div>
    <div class="more-btn-container">
      <router-link
        style="text-decoration: none"
        :to="{ name: 'LatestNews' }"
        v-bind:target="openDetailsInNewTab ? '_blank' : null"
      >
        <q-btn class="see-more-btn" outline>
          Meer <i class="las la-2x la-arrow-right"></i>
        </q-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import moment from 'moment';
import store from '../../store/index';
export default {
  props: {
    newsProp: Array,
    title: String,
  },
  setup() {
    const formatDate = (date) => {
      return moment(date).format('DD-MM-YYYY');
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    return {
      formatDate,
      openDetailsInNewTab,
    };
  },
};
</script>
